import { Formik } from "formik";
import { OctagonAlert } from "lucide-react";
import { useState } from "react";
import {
  Alert,
  Button,
  Collapse,
  Form,
  Modal,
  Spinner,
  Stack,
} from "react-bootstrap";
import * as Yup from "yup";

import shipmentsService from "../../../../services/shipmentService";

const CreateRackModal = ({
  showRackItemModal,
  setShowRackItemModal,
  setCreateRackItemResult,
}) => {
  const [error, setError] = useState(null);

  return (
    <Modal
      show={showRackItemModal}
      onHide={() => setShowRackItemModal(false)}
      backdrop="static"
      size="sm"
    >
      <Modal.Header closeButton>
        <Modal.Title>Create New Rack Item</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && (
          <Alert variant="danger" className="flex-fill alert-blink">
            <div className="alert-icon">
              <OctagonAlert
                className="position-relative top-50 start-50 translate-middle"
                size={20}
              />
            </div>
            <div className="alert-message font-weight-bold">
              {error.message}
            </div>
          </Alert>
        )}
        <Formik
          enableReinitialize
          initialValues={{ listingLabel: "", shipmentRackId: "" }}
          validationSchema={Yup.object().shape({
            listingLabel: Yup.string().required("Rack item label is required."),
            shipmentRackId: Yup.number()
              .typeError("Rack ID must be a number.")
              .required("Rack ID is required."),
          })}
          onSubmit={async (values) => {
            setError(null);
            setCreateRackItemResult(null);

            const listingLabel =
              values.listingLabel != null && values.listingLabel !== ""
                ? values.listingLabel.toUpperCase().trim()
                : null;

            const shipmentRackId =
              values.shipmentRackId != null && values.shipmentRackId !== ""
                ? Number(values.shipmentRackId)
                : null;

            const result = await shipmentsService.createShipmentRackItem({
              shipmentRackId,
              fnsku: listingLabel,
            });

            if (result.success) {
              setCreateRackItemResult({
                message: "Rack Item successfully created.",
                newShipmentRackItem: result.newShipmentRackItem,
              });

              setTimeout(setShowRackItemModal(false), 3000);
            } else {
              setError({ message: result.message });
            }
          }}
        >
          {({
            handleChange,
            handleBlur,
            setFieldTouched,
            handleSubmit,
            handleReset,
            setFieldValue,
            touched,
            dirty,
            isSubmitting,
            isValid,
            errors,
            values,
          }) => (
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label className="mb-0">
                  Rack Item Label<span className="text-danger ms-1">*</span>
                </Form.Label>
                <Form.Control
                  // ref={listingLabelInputRef}
                  required
                  autoFocus
                  name="listingLabel"
                  size="lg"
                  placeholder="Scan or Enter Rack Item Label..."
                  value={values.listingLabel}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  onFocus={(e) => {
                    e.target.select();
                  }}
                  onKeyUp={(e) => {
                    if (e.key === "Enter") {
                      if (Boolean(errors.listingLabel)) {
                        e.target.select();
                      } else {
                        // fromRackIdInputRef.current?.focus();
                      }
                    }
                  }}
                  isInvalid={Boolean(touched.toRackId && errors.listingLabel)}
                  disabled={isSubmitting}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.listingLabel}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label className="mb-0">
                  Rack ID<span className="text-danger ms-1">*</span>
                </Form.Label>
                <Form.Control
                  // ref={fromRackIdInputRef}
                  required
                  name="shipmentRackId"
                  size="lg"
                  placeholder="Scan or Enter Rack ID..."
                  value={values.shipmentRackId}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  onFocus={(e) => {
                    e.target.select();
                  }}
                  onKeyUp={(e) => {
                    if (e.key === "Enter") {
                      if (Boolean(errors.shipmentRackId)) {
                        e.target.select();
                      } else {
                        // toRackIdInputRef.current?.focus();
                      }
                    }
                  }}
                  isInvalid={Boolean(
                    touched.shipmentRackId && errors.shipmentRackId
                  )}
                  disabled={isSubmitting}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.shipmentRackId}
                </Form.Control.Feedback>
              </Form.Group>

              <Stack direction="horizontal">
                <Button
                  type="submit"
                  variant="outline-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <span>
                      <Spinner
                        className="me-2"
                        animation="border"
                        size="sm"
                        role="status"
                      />
                      Submitting...
                    </span>
                  ) : (
                    "Submit"
                  )}
                </Button>
                <div className="vr ms-3" />
                <Collapse in={dirty} dimension="width">
                  <div>
                    <Button
                      className="ms-3"
                      variant="outline-danger"
                      onClick={handleReset}
                      disabled={isSubmitting || !dirty}
                    >
                      Reset
                    </Button>
                  </div>
                </Collapse>
                <Button
                  className="ms-3"
                  variant="outline-secondary"
                  onClick={() => {
                    handleReset();
                    setShowRackItemModal(false);
                  }}
                  disabled={isSubmitting}
                >
                  Cancel
                </Button>
              </Stack>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

export default CreateRackModal;
